// app-pages/PaymentsPage/CryptoPaymentsModal/queries/usePaymentStatus.ts
"use client";
import { useQuery } from "@tanstack/react-query";
import { fetch } from "libs";
import { GET_PAYMENT_STATUS } from "api";

async function fetchPaymentStatus(): Promise<any> {
  const response = await fetch(GET_PAYMENT_STATUS, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });

  return response;
}

export default function usePaymentStatus(payment_method: string | undefined) {
  return useQuery({
    queryKey: ["cryptoEstimate"],
    queryFn: () => fetchPaymentStatus(),
    enabled: payment_method === "crypto",
  });
}
